/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'details': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<g transform="translate(.74 -.5)" _fill="none" fill-rule="evenodd"><path pid="0" d="M1.608 5.06V3.914M1.608 9.06V4.716M2.1 1.277a1.126 1.126 0 1 1-1.125 1.95A1.126 1.126 0 0 1 2.1 1.276zM2.1 9.285a1.126 1.126 0 1 1-1.125 1.95A1.126 1.126 0 0 1 2.1 9.285z" _stroke="#376F99" stroke-linecap="round" stroke-linejoin="round"/><rect pid="1" _fill="#376F99" x="4.201" y="1.689" width="6.723" height="1.126" rx=".563"/><rect pid="2" _fill="#376F99" x="4.201" y="5.698" width="6.723" height="1.126" rx=".563"/><rect pid="3" _fill="#376F99" x="4.201" y="9.708" width="6.723" height="1.126" rx=".563"/></g>'
  }
})
